<div class="d-flex flex-column justify-content-center align-items-center">
  <img src="/assets/images/respond-edu.svg" alt="responed-edu" height="100" width="100" />
  <br />
  <label class="quicksand-bold-label">{{ message }}</label>
</div>
